import { useTranslation } from 'react-i18next';

type transferStepperConfigOutput = {
  label: string;
  completed: boolean;
}[];
//TODO: refactor and sync on config logic to apply on ClientSideWizardStepper
const useTransferStepperConfig = (completedSteps: number): transferStepperConfigOutput => {
  const { t } = useTranslation();
  return [
    { label: t('fundsTransferPage.TransferStepper.InitTransfer.Label.Text'), completed: completedSteps > 0 },
    { label: t('fundsTransferPage.TransferStepper.TransferConfirm.Label.Text'), completed: completedSteps > 1 },
    { label: t('fundsTransferPage.TransferStepper.TransferComplete.Label.Text'), completed: completedSteps > 2 },
  ];
};

export { useTransferStepperConfig };
